import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { MatDialog } from '@angular/material';
import { Router } from '@angular/router';
import { LocalService, ManagerService, SellerService, StoreService } from 'src/app/core';
import { QuizChallengeService } from 'src/app/core/services/quiz-challenge.service';
import { SellerRewardsDialogComponent } from 'src/app/shared/components/seller-rewards-dialog/seller-rewards-dialog.component';
import {
  ProgressInfoPopupComponent
} from 'src/app/shared/components/progress-info-popup/progress-info-popup/progress-info-popup.component';
import { PopupMessageService } from 'src/app/shared/message/services/message.service';

@Component({
  selector: 'app-activity-challenges',
  templateUrl: './activity-challenges.component.html',
  styleUrls: ['./activity-challenges.component.scss']
})
export class ActivityChallengesComponent implements OnInit {

  constructor(private sellerService: SellerService,
    private storeService: StoreService,
    private router: Router, private dialog: MatDialog,
    private managerService: ManagerService, private popupMessageService: PopupMessageService,
    private quizService: QuizChallengeService) { }

  userProfile: any;
  assignedChallenges: any;
  intialPageNo = 0;
  intialPageSize = 4;
  currentPageNo = 1;
  @Input() challengeFlag: any;
  @Output() editChallengeItem = new EventEmitter();
  @Input() isCiscoAdmin: boolean = false;
  selectedPageNo: any;
  pviEligible: boolean = false;
  isDrawerOpen = false;
  selectedChallenge: any = null;
  activeDrawerType: string | null = null;
  isTermsOpen = false;
  termsChallenge: any = null;
  showProofModal: boolean = false;
  selectedProofActivity: any = null;
  showLaunchModal: boolean = false;
  launchModalData: any = null;
  showUploadDocModal: boolean = false;
  uploadDocModalData: any = null;

  ngOnInit() {
    this.userProfile = LocalService.get('userProfile');

    if (this.userProfile.hasOwnProperty('userType') && this.userProfile.userType == 'PAM') {
      const pamDataList = LocalService.get('pamData');
      const beGeoIds = pamDataList.pamBeGeoIdsDTO ? pamDataList.pamBeGeoIdsDTO.beGeoIds : pamDataList.beGeoIds;
      const beGeoItem = (beGeoIds.content && beGeoIds.content.length > 0)
        ? beGeoIds.content[0]
        : (beGeoIds.length > 0 ? beGeoIds[0] : null);
      if (beGeoItem && beGeoItem.companyEligibleChallengesDTO && beGeoItem.companyEligibleChallengesDTO.pvieligible === false) {
        this.pviEligible = true;
      }
    }

    if (!this.isCiscoAdmin) {
      if (this.userProfile.roles.find((item: any) => item.name === 'CISCO_ADMIN')) {
        if (this.router.url == '/home/manager/manage-challenges' && this.userProfile.createSalesChg) {
          this.isCiscoAdmin = true;
        }
      }
      if (!this.isCiscoAdmin) {
        this.storeService.getIsciscoAdminFlag().subscribe((data: any) => {
          if (data != null) {
            this.isCiscoAdmin = data.isCiscoAdmin == true;
          }
        });
      }
    }

    if (
      this.userProfile.pvieligible === false ||
      (this.userProfile.companyEligibleChallengesDTO && this.userProfile.companyEligibleChallengesDTO.pvieligible === false)
    ) {
      this.pviEligible = true;
    }

    if (this.challengeFlag == 'viewActivityChallengeLeader') {
      if (this.isCiscoAdmin) {
        this.getQuizChallengeList();
      } else {
        this.getChallengesByManager();
      }
    } else {
      this.getSaleChallengesSeller();
    }
  }

  getSaleChallengesSeller(pageNumber?: number) {
    this.currentPageNo = pageNumber !== undefined ? pageNumber + 1 : 1;
    const params = {
      sellerId: this.userProfile.id,
      category: this.challengeFlag === 2 ? 'GENERAL_ACTIVITY' : this.challengeFlag === 3 ? 'SPECIAL_ACTIVITY' : 'ASSIGNED_ACTIVITY',
      page: pageNumber ? pageNumber : this.intialPageNo,
      size: this.intialPageSize
    };
    this.sellerService.getSaleChallengesSeller(params).subscribe((data: any) => {
      this.assignedChallenges = data;
    }, (_err: any) => {
    });
  }

  getChallengesByManager(pageNumber?: number) {
    this.currentPageNo = pageNumber !== undefined ? pageNumber + 1 : 1;
    const params = {
      page: pageNumber ? pageNumber : this.intialPageNo,
      size: this.intialPageSize,
      companyId: this.userProfile.company.id
    };
    const query = this.userProfile.id + '?page=' + params.page + '&size=' + params.size + '&companyId=' + params.companyId;
    this.managerService.getChallengesByManager(query).subscribe((data: any) => {
      this.assignedChallenges = data;
    }, (_err: any) => {
    });
  }

  getQuizChallengeList(pageNumber?: number) {
    const SelectedPageNumber = this.storeService.getActivityChallengePageNum();
    this.currentPageNo = pageNumber !== undefined ? pageNumber + 1 : 1;
    const params = {
      page: pageNumber ? pageNumber : this.intialPageNo,
      size: this.intialPageSize,
    };
    if (SelectedPageNumber) {
      params.page = Number(SelectedPageNumber) - 1;
      this.currentPageNo = Number(SelectedPageNumber);
    }
    this.quizService.getQuizChallengeList('?page=' + params.page + '&size=' + params.size).subscribe((response: any) => {
      this.assignedChallenges = response;
      this.storeService.clearActivityChallengePageNum();
    });
  }

  showMoreBonusSalesChallenges(pageNumber: number) {
    this.selectedPageNo = pageNumber;
    if (this.challengeFlag == 'viewActivityChallengeLeader') {
      if (this.isCiscoAdmin) {
        this.getQuizChallengeList(pageNumber - 1);
      } else {
        this.getChallengesByManager(pageNumber - 1);
      }
    } else {
      this.getSaleChallengesSeller(pageNumber - 1);
    }
  }

  goToClaimTab(activeFlag: any) {
    this.storeService.setPreviousRoute(activeFlag);
    this.router.navigateByUrl('/home/seller/manage-claims');
  }

  openDrawer(challenge: any) {
    const type = challenge.type.name;
    if (type === 'Training Challenge') {
      this.activeDrawerType = 'training';
    } else if (type === 'Bookings Challenge') {
      this.activeDrawerType = 'booking';
    } else if (type === 'Architecture Challenge') {
      this.activeDrawerType = 'Architecture';
    } else if (type === 'Quiz Challenge') {
      this.activeDrawerType = 'quiz';
    } else if (type === 'Participation Challenge') {
      this.activeDrawerType = 'participation';
    } else if (type === 'Product Booking Challenge') {
      this.activeDrawerType = 'productBooking';
    }
    this.selectedChallenge = challenge;
    this.isDrawerOpen = true;
  }

  closeDrawer() {
    this.isDrawerOpen = false;
    this.activeDrawerType = null;
  }

  openTermsModal(challenge: any) {
    this.termsChallenge = challenge;
    this.isTermsOpen = true;
  }

  closeTermsModal() {
    this.isTermsOpen = false;
    this.termsChallenge = null;
  }

  editChallenge(challenge: any) {
    challenge.showSpinner = true;
    let challengeName = challenge.type.shortName.toLowerCase().trim();
    if (challengeName === 'bookings') { challengeName = 'booking'; }
    if (challengeName === 'training') { challengeName = 'enablement'; }
    if (challengeName === 'participation') { challengeName = 'participants'; }
    if (challengeName === 'product bookings') { challengeName = 'productsBooking'; }
    if (!this.isCiscoAdmin) {
      this.managerService.getActivityChallengeById(challengeName, challenge.id).subscribe((data: any) => {
        data.type = challenge.type;
        this.editChallengeItem.emit(data);
      }, (_err: any) => {
        challenge.showSpinner = false;
      });
    } else {
      this.managerService.getAdminActivityChallengeById(challengeName, challenge.id).subscribe((data: any) => {
        data.type = challenge.type;
        this.storeService.setActivityChallengePageNum(this.selectedPageNo);
        this.editChallengeItem.emit(data);
      }, (_err: any) => {
        challenge.showSpinner = false;
      });
    }
  }

  deleteChallenge(challengeId: any) {
    const lang = localStorage.getItem('selectedLanguage');
    this.storeService.addHeaderClass.next(true);
    const dialogRef = this.dialog.open(SellerRewardsDialogComponent, {
      width: '450px',
      data: { name: 'deletequizQuestion' },
    });
    dialogRef.afterClosed().subscribe((result: any) => {
      if (result) {
        if (this.isCiscoAdmin) {
          this.managerService.deleteActivityChallenge(challengeId).subscribe((data: any) => {
            let msg = 'Challenge deleted successfully.';
            if (lang == 'Korean') { msg = '챌린지가 성공적으로 삭제되었습니다.'; }
            if (lang == 'Japanese') { msg = 'チャレンジを削除しました。'; }
            this.popupMessageService.showSuccess(msg, 'success');
            this.getQuizChallengeList();
          }, (_err: any) => {
          });
        } else {
          this.managerService.deleteActiveChallenge(challengeId).subscribe((data: any) => {
            let msg = 'Challenge deleted successfully.';
            if (lang == 'Korean') { msg = '챌린지가 성공적으로 삭제되었습니다.'; }
            if (lang == 'Japanese') { msg = 'チャレンジを削除しました。'; }
            this.popupMessageService.showSuccess(msg, 'success');
            this.getChallengesByManager();
          }, (_err: any) => {
          });
        }
      }
      this.storeService.addHeaderClass.next(false);
    });
  }

  cloneChallenge(challenge: any) {
    challenge.showCloneSpinner = true;
    let challengeName = challenge.type.shortName.toLowerCase().trim();
    if (challengeName === 'bookings') { challengeName = 'booking'; }
    if (challengeName === 'training') { challengeName = 'enablement'; }
    if (challengeName === 'participation') { challengeName = 'participants'; }
    if (challengeName === 'product bookings') { challengeName = 'productsBooking'; }
    if (challengeName === 'quiz challenge') { challengeName = 'quizchallenge'; }
    this.managerService.cloneActivityChallengeById(challengeName, challenge.id).subscribe((data: any) => {
      data.type = challenge.type;
      data.isClone = true;
      this.editChallengeItem.emit(data);
    }, (_err: any) => {
      challenge.showCloneSpinner = false;
    });
  }

  updateStatus(data: any) {
    this.launchModalData = data;
    this.showLaunchModal = true;
  }

  confirmLaunch() {
    const reqParam = '?status=READY_TO_LAUNCH&id=' + this.launchModalData.id;
    this.managerService.updateActivityChallengeStatus(reqParam).subscribe((_response: any) => {
      this.popupMessageService.showSuccess('Activity challenge launched successfully', 'success');
      this.getQuizChallengeList(this.selectedPageNo - 1);
    });
    this.showLaunchModal = false;
    this.launchModalData = null;
  }

  closeLaunchModal() {
    this.showLaunchModal = false;
    this.launchModalData = null;
  }

  showProgressInfo(list: any) {
    this.managerService.getProductBookingProgress(list.userChallengeId).subscribe((data: any) => {
      if (data) {
        data.challengeName = list.name;
        this.dialog.open(ProgressInfoPopupComponent, {
          data,
          width: '50%',
          height: '500px',
          panelClass: 'progress-info',
        });
      }
    }, (_err: any) => {
      this.popupMessageService.showError('Something went wrong', 'error');
    });
  }

  showUploadDocumentPopUp(list: any, fileName: any, showOnlyTerms = false) {
    if (showOnlyTerms) {
      const termsWindow = window.open(list.termsAndConditionsUrl, '_blank');
      if (termsWindow) {
        termsWindow.focus();
      }
    } else {
      this.uploadDocModalData = { fileData: list, name: fileName, showOnlyTerms };
      this.showUploadDocModal = true;
    }
  }

  closeUploadDocModal(refreshData = false) {
    this.showUploadDocModal = false;
    this.storeService.addHeaderClass.next(false);
    if (refreshData && this.isCiscoAdmin) {
      this.getQuizChallengeList(this.selectedPageNo - 1);
    }
    this.uploadDocModalData = null;
  }

  openProofOfDocumentsModal(activityData: any) {
    this.selectedProofActivity = activityData;
    this.showProofModal = true;
  }

  uploadCompletionsDialog(list: any) {
    const dialogRef = this.dialog.open(SellerRewardsDialogComponent, {
      data: { 'name': 'uploadCompletions', 'challengeData': list },
      panelClass: 'upload-Completions',
      width: '50%',
      height: '400px',
    });
    dialogRef.afterClosed().subscribe((_result: any) => {
    });
  }
}
